import React, { useState } from "react";

import { DetailedPaymentMethod } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/admin/v1/payment_method_pb";
import {
  CreditCardDetails,
  PayPalAccountDetails,
} from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/payment_method_pb";

import { PaymentMethodsContext } from "./payment-methods-context";

interface PaymentMethodsContextWrapperProps {
  children: React.ReactNode;
}

const PaymentMethodsContextWrapper = ({
  children,
}: PaymentMethodsContextWrapperProps) => {
  const [paymentMethods, setPaymentMethods] = useState<DetailedPaymentMethod[]>(
    [],
  );
  const [isPaymentMethodsLoading, setIsPaymentMethodsLoading] =
    useState<boolean>(false);

  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState<
    DetailedPaymentMethod | undefined
  >(undefined);
  const [defaultPaymentMethodDetails, setDefaultPaymentMethodDetails] =
    useState<CreditCardDetails | PayPalAccountDetails | undefined>(undefined);

  const paymentMethodsContextValue = {
    paymentMethods,
    setPaymentMethods,
    isPaymentMethodsLoading,
    setIsPaymentMethodsLoading,
    defaultPaymentMethod,
    setDefaultPaymentMethod,
    defaultPaymentMethodDetails,
    setDefaultPaymentMethodDetails,
  };

  return (
    <PaymentMethodsContext.Provider value={paymentMethodsContextValue}>
      {children}
    </PaymentMethodsContext.Provider>
  );
};

export default PaymentMethodsContextWrapper;
